import * as React from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
// tslint:disable-next-line:no-unused-variable
import { ICrudGetAction, TextFormat } from 'react-jhipster';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntity } from './book.reducer';
import { IBook } from 'app/shared/model/book.model';
// tslint:disable-next-line:no-unused-variable
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IBookDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ id: number }> {}

export class BookDetail extends React.Component<IBookDetailProps> {
  componentDidMount() {
    this.props.getEntity(this.props.match.params.id);
  }

  render() {
    const { bookEntity } = this.props;
    return (
      <Row>
        <Col md="8">
          <h2>
            Book [<b>{bookEntity.id}</b>]
          </h2>
          <dl className="jh-entity-details">
            <dt>
              <span id="name">Name</span>
            </dt>
            <dd>{bookEntity.name}</dd>
            <dt>
              <span id="iconName">Icon Name</span>
            </dt>
            <dd>{bookEntity.iconName}</dd>
            <dt>
              <span id="bannerName">Banner Name</span>
            </dt>
            <dd>{bookEntity.bannerName}</dd>
            <dt>
              <span id="bookUrl">Book Url</span>
            </dt>
            <dd>{bookEntity.bookUrl}</dd>
            <dt>
              <span id="description">Description</span>
            </dt>
            <dd>{bookEntity.description}</dd>
            <dt>
              <span id="createdDate">Created Date</span>
            </dt>
            <dd>
              <TextFormat value={bookEntity.createdDate} type="date" format={APP_DATE_FORMAT} />
            </dd>
            <dt>
              <span id="lastModifiedDate">Last Modified Date</span>
            </dt>
            <dd>
              <TextFormat value={bookEntity.lastModifiedDate} type="date" format={APP_DATE_FORMAT} />
            </dd>
            <dt>
              <span id="isFree">Is Free</span>
            </dt>
            <dd>{bookEntity.isFree ? 'True' : 'False'}</dd>
            <dt>Sport</dt>
            <dd>{bookEntity.sport ? bookEntity.sport.name : ''}</dd>
            <dt>Created By</dt>
            <dd>{bookEntity.createdBy ? bookEntity.createdBy.login : ''}</dd>
            <dt>Last Modified By</dt>
            <dd>{bookEntity.lastModifiedBy ? bookEntity.lastModifiedBy.login : ''}</dd>
          </dl>
          <Button tag={Link} to="/entity/book" replace color="info">
            <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
          </Button>&nbsp;
          <Button tag={Link} to={`/entity/book/${bookEntity.id}/edit`} replace color="primary">
            <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
          </Button>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = ({ book }: IRootState) => ({
  bookEntity: book.entity
});

const mapDispatchToProps = { getEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(BookDetail);
